module.exports = __webpack_public_path__ + "static/home-hero.81ff4ac7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home-hero.jpg
// module id = 523
// module chunks = 31059827780979 35783957827783